var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserGuide(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.3 18.1001H9.8C9.91046 18.1001 10 18.1896 10 18.3001V24.2001C10 24.3106 9.91046 24.4001 9.8 24.4001H5.5",
    stroke: "#5C5C5C",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 24.3999H13.6",
    stroke: "#5C5C5C",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6992 25.3001L27.0992 22.6001",
    stroke: "#5C5C5C",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6992 11.8002L29.7992 8.2002",
    stroke: "#5C5C5C",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6992 16.3002L29.7992 12.7002",
    stroke: "#5C5C5C",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6992 20.8002L29.7992 17.2002",
    stroke: "#5C5C5C",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2154 1.1328L19.1154 7.24614C19.045 7.279 19 7.34967 19 7.42737V31.286C19 31.4323 19.152 31.5291 19.2846 31.4672L32.3846 25.3539C32.455 25.321 32.5 25.2503 32.5 25.1726V1.31404C32.5 1.16772 32.348 1.07092 32.2154 1.1328Z",
    stroke: "#5C5C5C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 7.2998H36.8C36.9105 7.2998 37 7.38935 37 7.4998V31.3998C37 31.5103 36.9105 31.5998 36.8 31.5998H1.2C1.08954 31.5998 1 31.5103 1 31.3998V7.49981C1 7.38935 1.08954 7.2998 1.2 7.2998H19",
    stroke: "#5C5C5C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1 35.2002H17.0764C17.1521 35.2002 17.2225 35.2426 17.248 35.314C17.4716 35.9395 17.3077 37.0002 19 37.0002C20.5546 37.0002 20.5118 35.9389 20.7507 35.3134C20.7778 35.2427 20.8479 35.2002 20.9236 35.2002H37",
    stroke: "#5C5C5C",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.10078,
    cy: 14.5002,
    r: 1.3,
    fill: "#5C5C5C",
    stroke: "#5C5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGuide);
export default __webpack_public_path__ + "static/media/User Guide.2d6e0c6b815259d586ac9e7a04c498db.svg";
export { ForwardRef as ReactComponent };